import { jsx as r, jsxs as e } from "react/jsx-runtime";
import a from "../Icons/ArrowRight.js";
import c from "../Icons/Home.js";
import t from "../../utils/colors.js";
import d from "./BackButton/BackButton.js";
import p from "./ButtonContainer/ButtonContainer.js";
import { Background as f, Wrapper as h, Container as u, HomeButtonWrapper as s, HomeButtonIconHolder as n } from "./styled.js";
const j = ({
  items: o,
  showBreadCrumb: i = !0,
  noBorder: m = !1,
  homeLink: l = "https://www.service.vic.gov.au"
}) => i && o.length > 0 ? /* @__PURE__ */ r(f, { children: /* @__PURE__ */ e(h, { $noBorder: m, children: [
  /* @__PURE__ */ r(d, { items: o }),
  /* @__PURE__ */ r(u, { children: /* @__PURE__ */ e(s, { href: l, title: "Homepage", children: [
    /* @__PURE__ */ r(n, { mode: "main", children: /* @__PURE__ */ r(c, { fill: t.orange }) }),
    /* @__PURE__ */ r(n, { mode: "secondary", children: /* @__PURE__ */ r(a, { fill: t.orange }) })
  ] }) }),
  /* @__PURE__ */ r(p, { items: o })
] }) }) : null;
export {
  j as BreadCrumb,
  j as default
};
